import actionTypes from '../constants/action-types';

const setDisplayMode = (value) => ({
  type: actionTypes.SET_DISPLAY_MODE,
  payload: { value },
});

export default setDisplayMode;
